export class LaborOperation {
    constructor() {}

    public id: string = "";
    public name: string = "";
}